import React, { useEffect, useState } from "react";
import { apiService } from "../../constants/ApiService";
import { toast } from "react-toastify";
import { Button, Input } from "reactstrap";
import useVendorBranch from '../../utils/useVendorBranch';
import conditionalDataLoad from '../../utils/conditionalDataLoad';
import { useSelector } from 'react-redux';
import VendorBranchSelector from '../../components/VendorBranchSelector';
import { set } from "date-fns";

const CommonImportExport = () => {
  const [errorMessage, setErrorMessage] = useState({});
    const { user } = useSelector((state) => state.authState);
  
    const { isSuperAdmin, isAdmin, hasMultiBranch, hasSingleBranch } =
      useVendorBranch(user);
  
    const [file, setFile] = useState(null);
    const [loading, setLoading] = useState(false);
    const [response, setResponse] = useState(null);
    const [expTbl, setExpTbl] = useState([]);
    const [importedHeaders, setImportedHeaders] = useState([]);
    const [importedData, setImportedData] = useState([]);
    const [exportedHeaders, setExportedHeaders] = useState([]);
  const [rawDataheaderData, setRawDataheaderData] = useState([]);


    // Example ExcelImportReq fields
    const [formDataState, setFormDataState] = useState({
        id: null,
        import_purpose: "",
        export_table_id: "",
        vender_master_id: "",
        branch_master_id: "",
        remark: ""
    });

    const handleChange = (e) => {
        setFormDataState({
            ...formDataState,
            [e.target.name]: e.target.value
        });
    };

    const handleFileChange = (e) => {
        setFile(e.target.files[0]);
    };

    const handleSubmit = async () => {
        if (!file) {
            alert("Please select an Excel file");
            return;
        }

        const formData = new FormData();

        // 🔹 ExcelImportReq object
        formData.append("id", formDataState.id ?? "");
        formData.append("import_purpose", formDataState.import_purpose);
        formData.append("export_table_id", formDataState.export_table_id);
        formData.append("vender_master_id", formDataState.vender_master_id);
        formData.append("branch_master_id", formDataState.branch_master_id);
        formData.append("remark", formDataState.remark);

        // 🔹 File
        formData.append("file", file);

        try {
            setLoading(true);

            const res = await apiService.post(
                "/api/ExcelDataImportExport/ReadExcelFile",
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    }
                }
            );

            setResponse(res);
            if (res.status) {
                toast.success("File uploaded successfully");
                setFormDataState({
                    ...formDataState,
                    id: res.lastInsertedId
                });
                setImportedHeaders(res.importHeaders);
                setImportedData(res.importedData);
                console.log(res, "res excel")

                // FOR SENDING TO API
                const normalizedHeaders = normalizeHeaders(res.exportHeaders);
                setExportedHeaders(normalizedHeaders);
                setActiveStep(1);
            } else {
                toast.error(res.message);
            }
        } catch (err) {
            console.error(err);
            toast.error(err.response?.data?.Message || "Upload failed");
        } finally {
            setLoading(false);
        }
    };

    const normalizeHeaders = (exportHeaders) => {
  return exportHeaders.map((exp) => ({
    id: null,                       // IMPORTED column id (not mapped yet)
    import_col_id: null,                // IMPORTED column name
    column_name: "",                // IMPORTED column name
    column_position: 0,             // IMPORTED column position
    export_column_position: exp.column_position, // EXPORT column id
    export_column_name: exp.column_name,
    export_col_id: exp.id,

  }));
};


    const fetchExportTables = async () => {
        setLoading(true);

        try {
            const res = await apiService.get(
                "/api/ExcelExportConfiguration/GetAllExportTables",
            );
            if (res.status) {
                setExpTbl(res.dataList);
            } else {
                alert(res.message);
            }
        } catch (err) {
            console.error(err);
            alert("Failed to load data");
        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {
        fetchExportTables();
    }, []);

const handleCustomPositionChange = (exportColumnId, importColumnId) => {
  const imported = importedHeaders.find(
    (i) => i.id === Number(importColumnId)
  );

  setExportedHeaders((prev) =>
    prev.map((h) =>
      h.export_col_id === exportColumnId
        ? {
            ...h,
            import_col_id: imported.id,
            column_name: imported.column_name,
            column_position: imported.column_position
          }
        : h
    )
  );
};

// const checkFx = () => {
//     console.log(exportedHeaders);
// }


  const handleRemoveCustomPositionChange = (ExportHeaderId) => {
    // const exportHeader = bankExportHeaderTable.find(
    //   (data) => data.export_column_position === Number(ExportHeaderId)
    // );

    setRawDataheaderData((prev) => {
      const updated = [ ...prev ];

      // Find the header in rawDataheaderData by import_header_id
      const headersCopy = [...updated.headers];
      const headerIndex = headersCopy.findIndex(
        (h) => h.export_column_position === Number(ExportHeaderId)
      );

      if (headerIndex !== -1) {
        headersCopy[headerIndex] = {
          ...headersCopy[headerIndex],
          export_column_position: null,
          export_column_name: "",
        };
      }

      updated.headers = headersCopy;
      return updated;
    });
  }

  
  const SubmitMappingImportToExport = async () => {
    try {

   
      setLoading(true);
    //   if (rawDataheaderData.headers.length > 0) {
    //     const hasAtLeastOnePosition = rawDataheaderData.headers.some(
    //       row => row.export_column_position != null
    //     );

    //     if (!hasAtLeastOnePosition) {
    //       setErrorMessage({ rowData: "No export column positions are set. Please add at least one 'Import Col. Name' for the header before proceeding." });
    //       setShowErrorModal(true);

    //       return
    //     }
    //   }


      // const errors = validateInputs();
      // if (Object.keys(errors).length > 0) {
      //   setErrorMessage(errors);
      //   setShowErrorModal(true)
      //   setIsSubmitting(false);

      //   return;
      // } else {
      //   setErrorMessage({})
      // }

      let params = {
        headers : exportedHeaders,
        import_log_id : formDataState.id,
        // vender_master_id: bankExportData.vender_master_id,
        // branch_master_id: bankExportData.branch_master_id,
      }

      // await uploadImagesFromArrayWithIndex(params)

      let config = {
        headers: {
          'Content-Type': 'application/json', // Important for file upload//s
          'accept': 'application/json'
        }
      };

      const response = await apiService.post(`/api/ExcelDataImportExport/MappingImport_To_Export`, params, config)
      if (response.response && response.response.data.errors) {
        toast.success(response.response?.data?.errors);
      }

      if (response.status === true) {
        toast.success(response.message);
        setActiveStep(2);
       // setHeaderFlag(response.headerFlag)
        // getBankExchangeData(response.bankExchangeMasterById.id)
      }
      else {
        toast.error(response.message);
      }
    } catch (error) {
      console.log(error)
      toast.error(`SomeThing went wrong!!`);
    } finally {
      setLoading(false); // Re-enable button
    }
  };

  const downloadJson = async (importLogId) => {
  try {
    const response = await apiService.get(
      `/api/ExcelDataImportExport/download-json/${importLogId}`,
      {
        responseType: "blob", // 🔴 VERY IMPORTANT
      }
    );

    // Create file URL
    const url = window.URL.createObjectURL(
      new Blob([response.data], { type: "application/json" })
    );

    // Create temporary link
    const link = document.createElement("a");
    link.href = url;

    // Optional: filename from backend header
    const contentDisposition = response.headers["content-disposition"];
    let fileName = "export.json";

    if (contentDisposition) {
      const match = contentDisposition.match(/filename="?(.+)"?/);
      if (match?.[1]) fileName = match[1];
    }

    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();

    // Cleanup
    link.remove();
    window.URL.revokeObjectURL(url);

  } catch (error) {
    console.error("Download failed:", error);
    alert("Failed to download file");
  }
};


  const importDataInTables = async () => {
    debugger;
    setLoading(true);

    try {
      const res = await apiService.get(
        "/api/ExcelDataImportExport/import-to-tbl?importLogId=" + formDataState.id,
      );
      if (res.status) {
        toast.success("Data imported successfully");
      } else {
        toast.error(res.message);
      }
    } catch (err) {
      console.error(err);
      toast.error("Failed to load data");
    } finally {
      setLoading(false);
    }
  };


    const steps = [
        { id: 0, label: 'Upload Excel' },
        { id: 1, label: 'Map Columns' },
        { id: 2, label: 'Download Results' }
    ];

    const [activeStep, setActiveStep] = useState(0);
    return (
        <>
            {/* <button onClick={checkFx}>Check</button> */}


             <VendorBranchSelector
                user={user}
                selectionData={formDataState}
                setSelectionData={setFormDataState}
                errorMessage={errorMessage}
                accessButton={true}
              />

            <div className="card p-3 shadow-sm">
                <div class='wizard-content'>
                    <div class='tab-wizard wizard-circle wizard clearfix'>
                        <div class='steps clearfix'>
                            <ul role='tablist' className='steps mb-3'>
                                {steps.map((step, index) => {
                                    const isCurrent = activeStep === index;
                                    const isDone = index < activeStep;
                                    const isDisabled = index > activeStep;

                                    return (
                                        <li
                                            key={step.id}
                                            role='tab'
                                            className={`
                                                ${index === 0 ? 'first' : ''}
                                                ${index === steps.length - 1 ? 'last' : ''}
                                                ${isCurrent ? 'current' : ''}
                                                ${isDone ? 'done' : ''}
                                                ${isDisabled ? 'disabled' : ''}
                                            `}
                                            aria-disabled={isDisabled}
                                            aria-selected={isCurrent}
                                        >
                                            <a
                                                href='#'
                                                id={`steps-${step.id}-t-${index}`}
                                                aria-controls={`steps-${step.id}-p-${index}`}
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    if (!isDisabled) setActiveStep(index);
                                                }}
                                            >
                                                {isCurrent && (
                                                    <span className='current-info audible'>
                                                        current step:
                                                    </span>
                                                )}
                                                <span className='step'>{index + 1}</span> {step.label}
                                            </a>
                                        </li>
                                    );
                                })}
                            </ul>
                        </div>

                        {activeStep === 0 && (
                            <>
                                <h5>Import Excel File</h5>

                                <div className="mb-2">
                                    <label>Import Purpose</label>
                                    <input
                                        type="text"
                                        name="import_purpose"
                                        className="form-control"
                                        value={formDataState.import_purpose}
                                        onChange={handleChange}
                                    />
                                </div>

                                <div className="mb-2">
                                    <label>Linked to Table </label>
                                    <select
                                        name="export_table_id"
                                        className="form-control"
                                        value={formDataState.export_table_id}
                                        onChange={handleChange}
                                    >
                                        <option value="">-Select Table-</option>
                                        {expTbl.map((table) => (
                                            <option key={table.id} value={table.id}>
                                                {table.tbl_name}
                                            </option>
                                        ))}
                                    </select>
                                </div>

                                <div className="mb-2">
                                    <label>Remark</label>
                                    <input
                                        type="text"
                                        name="remark"
                                        className="form-control"
                                        value={formDataState.remark}
                                        onChange={handleChange}
                                    />
                                </div>

                                <div className="mb-3">
                                    <label>Select Excel File (.xlsx)</label>
                                    <input
                                        type="file"
                                        className="form-control"
                                        accept=".xlsx"
                                        onChange={handleFileChange}
                                    />
                                </div>

                                <button
                                    className="btn btn-primary"
                                    onClick={handleSubmit}
                                    disabled={loading}
                                >
                                    {loading ? "Uploading..." : "Upload Excel"}
                                </button>
                            </>
                        )}

                         {activeStep === 1 && (
                            <>
                            <h5>Mapping Import & Export Columns </h5>

                            <table className="table table-bordered w-100"
                            >
                              <thead>
                                <tr>
                                  <th style={{ width: "40px" }}>⠿</th>
                                  <th style={{ width: "120px" }}>Position No.</th>
                                  <th>Display Column</th>
                                  <th>Import Col. Name</th>
                                  <th>Action</th>
                                </tr>
                              </thead>
                              <tbody>
                                {exportedHeaders.map((col, index) => (
                                  <tr>
                                    <td style={{ textAlign: "center" }}>::</td>
                                    <td style={{ textAlign: "center" }}>
                                      {col.export_column_position}
                                    </td>
                                    <td>{col.export_column_name}</td>
                                    <td>
                                      <Input
                                        type="select"
                                        value={col.import_col_id ?? ""}
                                        onChange={(e) =>{
                                           handleCustomPositionChange(col.export_col_id, e.target.value)
                                            console.log("Selected:", exportedHeaders);
                                        }}
                                        className="mb-2 custom-select"
                                        // disabled={exportedHeaders?.find(
                                        //   (h) => h.export_col_id == col.id
                                        // )?.id != null}
                                      >
                                        <option value=""> - Select - </option>
                                        {importedHeaders?.map((data) => {

                                          let match = data.export_column_position != null
                                          return (
                                            <option
                                              key={data.id}
                                              value={data.id}
                                              disabled={match} // ✅ disable if used in another row
                                            >
                                              {data.column_name}
                                            </option>
                                          );
                                        })}
                                      </Input>
                                    </td>

                                    <td>
                                      {importedHeaders?.find(
                                        (h) => h.export_column_position == col.id
                                      )?.id != null
                                        &&
                                        <Button type='button' className='btn btn-primary' color='primary'
                                          onClick={() => { handleRemoveCustomPositionChange(col.id) }}>
                                          UnSelected
                                        </Button>}
                                    </td>


                                  </tr>
                                ))}
                              </tbody>
                            </table>

                             <button
                                    className="btn btn-primary"
                                    onClick={SubmitMappingImportToExport}
                                    disabled={loading}
                                >
                                    {loading ? "Saving..." : "Save Mapping"}
                                </button>

                                <pre>
                                    {JSON.stringify(importedData, null, 2)}
                                </pre>
                            </>
                         )}

                         
                         {activeStep === 2 && (
                            <>
                               <button
                                    className="btn btn-warning"
                                    onClick={() => downloadJson(formDataState.id)}
                                    disabled={loading}
                                >
                                    {loading ? "Downloading..." : "Download Json"}
                                </button>
                               <button
                                    className="btn btn-primary"
                                    onClick={importDataInTables}
                                    disabled={loading}
                                >
                                    {loading ? "Importing..." : "Import Data"}
                                </button>
                            </>
                         )}

                        {response && (
                            <pre className="mt-3 bg-light p-2">
                                {JSON.stringify(response, null, 2)}
                            </pre>
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};

export default CommonImportExport;
